<app-mobile-header></app-mobile-header>

<ejs-dialog
  [isModal]="true"
  [showCloseIcon]="true"
  [visible]="showZoneSelectionDialog"
  [width]="'420px'"
  (close)="onZoneDialogClosed()">
  <ng-template #header>
    {{ 'i18n.domain.mobile-landing.zone-selection.title' | translate }}
  </ng-template>
  <ng-template #content>
    <p class="zone-selection-dialog-description">{{ 'i18n.domain.mobile-landing.zone-selection.description' | translate }}</p>
    <label class="control-label"> {{ 'i18n.domain.mobile-landing.zone-selection.label' | translate }} </label>
    <ejs-dropdownlist
      id="zone-selection-dropdown"
      class="w-100"
      [dataSource]="zoneSelectionItems"
      [fields]="zoneDropdownFields"
      [showClearButton]="false"
      [value]="selectedZoneId"
      [placeholder]="'i18n.domain.mobile-landing.zone-selection.placeholder' | translate"
      (valueChange)="selectedZoneId = $event">
    </ejs-dropdownlist>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2" (click)="onCancelZoneSelection()">
      {{ 'i18n.shared.cancel' | translate }}
    </button>
    <button class="btn btn-primary" [disabled]="!selectedZoneId" (click)="onConfirmZoneSelection()">
      {{ 'i18n.shared.ok' | translate }}
    </button>
  </ng-template>
</ejs-dialog>

@if(showError) {
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 mt-5">
      <div class="alert alert-danger text-center" role="alert">
        {{ errorMessage | translate }}
      </div>
    </div>
  </div>
}
